import { TabType } from '@wildberries/ui-kit';

type TParams = {
  routeName: string;
  tabsConfig: Array<TabType>;
};

export const getSelectedTabId = ({ routeName, tabsConfig }: TParams): string =>
  tabsConfig.reduce((acc, { link, id }) => {
    if (Boolean(acc)) {
      return acc;
    }

    if (tabsConfig.length === 1) {
      return [...acc, tabsConfig[0].id].toString();
    }

    if (routeName.indexOf(link) !== -1) {
      return [...acc, id].toString();
    }

    return acc;
  }, '');
